import React from "react";
import "./css/Privacy.css";

const Privacy = () => {
  return (
    <div className="privacy-page">
      <h1>Privacy Policy</h1>
      <p>Last updated: July 2025</p>

      <section>
        <h2>1. Information We Collect</h2>
        <p>
          We collect data such as your name, email, and usage patterns to improve your experience. We never sell your personal information.
        </p>
      </section>

      <section>
        <h2>2. How We Use Information</h2>
        <p>
          Data is used for analytics, personalization, and customer support. We may use third-party tools to help us operate effectively.
        </p>
      </section>

      <section>
        <h2>3. Cookies</h2>
        <p>
          We use cookies to enhance performance and functionality. You can manage cookies through your browser settings.
        </p>
      </section>

      <section>
        <h2>4. Data Security</h2>
        <p>
          We implement strong security measures to protect your information. However, no system is 100% secure.
        </p>
      </section>

      <section>
        <h2>5. Contact Us</h2>
        <p>
          For privacy-related questions, contact us at <a href="mailto:support@officialripple.com">support@officialripple.com</a>.
        </p>
      </section>
    </div>
  );
};

export default Privacy;